import styled from 'styled-components';

const StyledButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default StyledButtonContent;
